import React from 'react';
import Sidebar from 'components/modules/shipper/AdminSidebar';

export default function ShipperSettings({ userId, activePage }) {
  return <Sidebar userId={userId} activePage={activePage} />;
}
